export const appStores = {
  ios: 'appStore',
  android: 'playStore'
};

export const daysReminder = 90;
export const daysHidden = 15;
